var app = require('derby').createApp(module)
  .use(require('../../ui'))
  .use(require('../../ui/form'))
  .use(require('../../ui/derbyPassportCustom'))
  .use(require('derby-ui-paginator'));

require('../view-helpers')(app);
var routes = require('./routes'),
	controllers = require('./controllers'),
	renderFns = require('./render-fns');

require('./routes/usage');
	
//Loading animation
app.exit('*', function() {
	document.getElementById('loading-overlay').style.display = 'block';
});

app.enter('*', function() {
	//Make Racer methods return promises in addition to accepting callbacks
	require('derby-promise');

	if (!require('derby').util.isServer) {
		//Temp hack until we get ads appearing correctly with client-side rendering
		$('#google-adsense-container').parent().hide();
	}

	//Close the siteNav dropdown if user clicks outside of it
	//Using jQuery for now (see controllers/siteNav.js for original); adding x-bind to <body> causes "Uncaught Error: Server and client page renders do not match"
	/*
	jQuery('body').click(function(e) {
		if (e.target.id != 'toggle-account-dropdown-link')
			app.model.set('_page.showAccountDropdown', false);
	});
	*/

//https://news.ycombinator.com/item?id=7924916
//http://www.google.com/doubleclick/publishers/welcome/
//http://www.google.com/doubleclick/publishers/small-business/#utm_source=dfp_welcome_learnmore&utm_medium=et&utm_campaign=dfp_welcome
//http://www.linkshare.com/advertisers/publishers/managing_your_account/link_types/easy_links_publishers/

//didn't seem to help:
//http://stackoverflow.com/questions/6197768/dynamic-adsense-insertion-with-javascript

// 	//Workaround for Google AdSense
// 
// 	var output = '';
// 	
// 	function write(str) {
// 		output += str + "\n";
// 	}
// 	
// 	//write('TEST')
// 	/*
// 	write("<script type=\"text\/javascript\"><!--");
// 	write("google_ad_client = \"ca-pub-5170957762701230\";");
// 	write("\/* right sidebar *\/");
// 	write("google_ad_slot = \"8926693106\";");
// 	write("google_ad_width = 160;");
// 	write("google_ad_height = 600;");
// 	write("\/\/-->");
// 	write("<\/script>");
// 	write("<script type=\"text\/javascript\"");
// 	write("src=\"\/\/pagead2.googlesyndication.com\/pagead\/show_ads.js\">");
// 	write("<\/script>");
// 	*/
// 	
// 	write("<script src=\"\/\/pagead2.googlesyndication.com\/pagead\/js\/adsbygoogle.js\"><\/script>");
// 	write("<!-- right sidebar -->");
// 	write("<ins class=\"adsbygoogle\"");
// 	write("     style=\"display:inline-block;width:160px;height:600px\"");
// 	write("     data-ad-client=\"ca-pub-5170957762701230\"");
// 	write("     data-ad-slot=\"8926693106\"><\/ins>");
// 	write("<script>");
// 	write("(adsbygoogle = window.adsbygoogle || []).push({});");
// 	write("<\/script>");
// 	
// 	
// 	document.getElementById('ad-container').innerHTML = output;
});